import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import InsightsMobile from './InsightsMobile';
import InsightsDesktop from './InsightsDesktop';

function Insights({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <InsightsMobile app={app} config={config} />
        : <InsightsDesktop app={app} config={config} />;
}

Insights.defaultProps = {
    app: null,
    config: {}
};

Insights.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default Insights;
